import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'flatpickr/dist/flatpickr.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './assets/css/style.css';
import './assets/css/mv-theme.css';
import './assets/css/home2.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
